import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Home.css'; // Reusing your global styles

function TermsAndConditions() {
  const navigate = useNavigate();

  return (
    <div className="home-wrapper bg-surface min-h-screen">
      <header className="modern-header">
        <div className="container header-flex">
          <div className="brand-box flex-center cursor-pointer" onClick={() => navigate('/')}>
            <img src="/logo.png" alt="Logo" className="nav-logo" onError={(e) => e.target.style.display='none'} />
            
          </div>
          <button className="btn-action-outline" onClick={() => navigate('/')}>← Back to Home</button>
        </div>
      </header>

      <main className="section-padding">
        <div className="container">
          <div className="card-editorial" style={{ maxWidth: '900px', margin: '0 auto' }}>
            <h1 className="section-title-large mb-8">Terms and Conditions</h1>
            <p className="text-subtitle mb-8">Last Updated: April 2026</p>

            <div className="prose" style={{ lineHeight: '1.8', color: '#444653' }}>
              <h3 className="section-title mb-4">1. General Provisions</h3>
              <p className="mb-6">
                Welcome to the official digital platform of the Bathinda Housing Complex Co-operative House Building Society Ltd[cite: 6]. By accessing and using this website, you agree to be bound by these terms and conditions. The operations of this Society and its digital platform are governed strictly by the Panjab Cooperative Societies Act, 1961, and the Panjab Cooperative Societies Rules, 1963[cite: 17, 19].
              </p>

              <h3 className="section-title mb-4">2. Digital Tendering System</h3>
              <ul className="mb-6" style={{ paddingLeft: '20px' }}>
                <li className="mb-2"><strong>Transparency:</strong> Our digital tendering system is designed to be completely transparent. Bid outcomes and preliminary rankings (such as L1, L2) are published in the public domain.</li>
                <li className="mb-2"><strong>Final Authority:</strong> While the website lists the outcomes of the bidding process, the final decision and authority to award any contract rests solely and exclusively with the Managing Committee of the Society[cite: 211, 246].</li>
                <li className="mb-2"><strong>Vendor Conduct:</strong> Vendors must ensure all submitted documents and bids are accurate. Any fraudulent activity will lead to immediate disqualification.</li>
              </ul>

              <h3 className="section-title mb-4">3. Online Payments</h3>
              <p className="mb-6">
                We facilitate the collection of society dues, including monthly charges, annual maintenance charges, and fines, through the Razorpay payment gateway. By initiating a payment, you agree to Razorpay's processing terms. The Society is not liable for transaction failures caused by network issues or banking downtime, though we will assist in resolving disputes regarding credited amounts.
              </p>

              <h3 className="section-title mb-4">4. Member Obligations</h3>
              <p className="mb-6">
                Users accessing the Member Panel must comply with the Society's bye-laws. Members are expected to maintain good character and fulfill their financial obligations to the Society promptly[cite: 60, 97]. Failure to pay dues or fines may result in restricted access to digital services or further action as per the bye-laws.
              </p>

              <h3 className="section-title mb-4">5. Contact Information</h3>
              <p className="mb-2">For any legal inquiries or clarifications regarding these terms, please contact the General Secretary:</p>
              <ul style={{ listStyle: 'none', padding: 0 }}>
                <li>📱 <strong>Mobile & WhatsApp:</strong> +91 9872348700</li>
                <li>✉️ <strong>Email:</strong> bhcchbs@gmail.com</li>
                <li>📍 <strong>Address:</strong> Housefed Colony, Bathinda, Punjab, India 151001</li>
              </ul>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default TermsAndConditions;